import React from 'react';
import { Link } from 'dva/router';
import * as tools from '../../../utils/processingTools';
import './index.scss';

class Finance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }
  
  componentWillMount(){
    this.props.selectBlogList();
    this.props.getArgs({type:'selectGoldProject',onscroll:false});
    this.props.getArgs({type:'selectProjectFiance',onscroll:false});
    
  }

  render() {
    let { informationList,financingList,projectList } = this.props;
    return (
      <div className='finance'>
        <div className='finance-banner'>
          <img src={require('../../../lib/images/finance_banner.png')}/>
          <div className='finance-banner-con'>
            <div className='banner-con-top'>
              <h2>投融资平台</h2>
              <p>解决资金问题的平台</p>
              <a href='https://chuangke.aliyun.com/project/my/#/projectedit' target='blank'>立即加入</a>
              {/* <Link to='/projectedit'>立即加入</Link> */}
            </div>
            <ul>
              <li>
                <img src={require('../../../lib/images/finance_banner_icon1.png')} />
                <span>双创专属基金申请</span>
              </li>
              <li>
                <img src={require('../../../lib/images/finance_banner_icon2.png')} />
                <span>顶级投资机构联盟</span>
              </li>
              <li>
                <img src={require('../../../lib/images/finance_banner_icon3.png')} />
                <span>风投面对面线下见面会</span>
              </li>
            </ul>
          </div>
        </div>
        <div className='finance-list'>
          <ul>
            <li className='finance-information'>
              <div className='finance-title'>
                <p>资讯</p>
                <Link onClick={()=>{
                  window.location.href = 'https://chuangke.aliyun.com/info/list';
                }
                }>查看更多></Link>
              </div>
              <div className='finance-information-con'>
                {informationList?informationList.map((item, index) => {
                  return (
                    <div className='finance-information-con-list' key={index} onClick={()=>{
                      window.open('/info/detail/'+item.aid);
                    }}>
                      <h4>{item.title}</h4>
                      <p>{item.abstractContent}</p>
                      <span>{item.ctime?item.ctime.split(' ')[0]:null}</span>
                    </div>
                  );
                }):null
                }
              </div>
              <div className='finance-fixed'>
                <div className='finance-fixed-gradient'></div>
                <Link className='finance-fixed-more' onClick={()=>{
                  window.location.href = 'https://chuangke.aliyun.com/info/list';
                }
                }>点击查看更多 
                  <img src={require('../../../lib/images/Fill 1.png')} />
                </Link>
              </div>
            </li>
            <li className='finance-recommend'>
              <div className='finance-title'>
                <p>发现新项目</p>
                <a href='https://chuangke.aliyun.com/project/my/#/projectedit' target='blank'>提交项目</a>
              </div>
              <div className='finance-recommend-con'>
                {projectList?projectList.map((item,index) => {
                  return (
                    <a className='finance-recommend-con-list' key={index} 
                      href={`/project/gold/detail/${item.projectId}`} target='blank'>
                      <div className='update-list-img'>
                        <img src={item.projectLogo?`${window.GLOBAL_CONFIG.image_host}/${item.projectLogo}`:
                          'https://img.alicdn.com/tfs/TB13j3eggoQMeJjy0FoXXcShVXa-184-184.png'} />
                      </div>
                      <div className='update-list-con'>
                        <p>{item.projectTitle}{(item.domain=='暂无' || item.domain==null)?null:<span onClick={(e)=>{
                          e.preventDefault();
                          e.stopPropagation();
                          window.open(`/finance/database/label/#/?domainCode=${item.domainCode}`);
                        }}>{item.domain}</span>}</p>
                        <p>{item.projectBrief}</p>
                      </div>
                    </a>
                  );
                }):null
                }
              </div>
              {projectList && projectList.length>0?<div className='finance-fixed'>
                <div className='finance-fixed-gradient'></div>
                <a className='finance-fixed-more' onClick={ ()=>{
                  window.open('/finance/database/project');
                } }>
                  点击查看更多
                  <img src={require('../../../lib/images/Fill 1.png')} />
                </a>
              </div>:null}
            </li>
            <li className='finance-update'>
              <div className='finance-title'>
                <p>融资快讯</p>
                <a onClick={ ()=>{
                  window.open('/finance/database/event');
                } }>查看更多
                </a>
              </div>
              <div className='finance-update-con'>
                {financingList?financingList.map((item, index) => {
                  return (
                    <a className='finance-update-con-list' key={index} 
                      href={`/project/gold/detail/${item.projectId}`} target='blank'>
                      {item.gmtCreated?
                        (<p className='update-con-list-time'>
                          {item.gmtCreated?item.gmtCreated.split(' ')[0]:null}
                          <span></span>
                          <span></span>
                        </p>):null}
                      {(item.domain=='暂无' || item.domain==null)?null:<span className='update-con-list-field' 
                        onClick={(e)=>{
                          e.preventDefault();
                          e.stopPropagation();
                          window.open(`/finance/database/label/#/?domainCode=${item.domainCode}`);
                        }}>{item.domain}</span>}
                      <div className='update-con-list-title'>
                        <div className='update-list-img'>
                          <img src={item.projectLogo?`${window.GLOBAL_CONFIG.image_host}/${item.projectLogo}`:
                            'https://img.alicdn.com/tfs/TB13j3eggoQMeJjy0FoXXcShVXa-184-184.png'} />
                        </div>
                        <div className='update-list-con'>
                          <p className='update-con-list-name'>{item.projectTitle}</p>
                          <p className='update-con-list-faq'>{item.projectBrief}</p>
                        </div>
                        <span></span>
                      </div>
                      <div className='update-con-list-con' 
                        dangerouslySetInnerHTML={{ __html: tools.replaceFun(item.investBrief) }}>
                      </div>
                    </a>
                  );
                }):null
                }
              </div>
              {financingList && financingList.length>0?
                <div className='finance-fixed'>
                  <div className='finance-fixed-gradient'></div>
                  <a className='finance-fixed-more' onClick={ ()=>{
                    window.open('/finance/database/event');
                  } }>
                  点击查看更多
                    <img src={require('../../../lib/images/Fill 1.png')} />
                  </a>
                </div>:null}
              
            </li>
          </ul>
        </div>
        <div className='finance-mechanism'>
          <div className='finance-title'>
            <p>投资机构联盟</p>
          </div>
          <ul>
            <li>
              <img src={require('../../../lib/images/finance_logo1.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo2.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo3.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo4.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo5.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo6.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo7.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo8.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo9.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo10.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo11.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo12.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo13.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo14.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo15.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo16.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo17.png')} />
            </li>
            <li>
              <img src={require('../../../lib/images/finance_logo18.png')} />
            </li>
          </ul>
            
        </div>
      </div>
    );
  }
}

export default Finance;


// WEBPACK FOOTER //
// ./src/scripts/components/Finance/Finance/index.js